var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPanicButtonHardware(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2A12 12 0 112 14 12.013 12.013 0 0114 2zm0-1.334a13.333 13.333 0 100 26.667A13.333 13.333 0 0014 .666z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.333l.666 9.333h2.667L16 7.333h-4zM14 18a1.332 1.332 0 100 2.664 1.332 1.332 0 000-2.665zM8.344 20.323a.667.667 0 01-.477-.19 8.667 8.667 0 010-12.267.667.667 0 01.942.943 7.333 7.333 0 000 10.37.667.667 0 01-.47 1.139l.005.005zM19.656 20.323a.666.666 0 01-.47-1.138 7.333 7.333 0 000-10.371.67.67 0 11.947-.948 8.667 8.667 0 010 12.256.666.666 0 01-.477.201z"
  })));
}
export default SvgPanicButtonHardware;